// extracted by mini-css-extract-plugin
export default {"wrapper":"nV-z","availablePromoMessagesLabel":"oV-z","promoMessageList":"pV-z","promoMessage":"qV-z","appliedPromoMessage":"rV-z","promoMessageAmount":"sV-z"};